// lineItems/renderers/manaswini.renderer.js
export const renderManaswiniItems = (items, showTax) => {
  const header = `
    <tr>
      <th>Sl</th>
      <th>Service</th>
      <th>Charges</th>
      <th>Units</th>
      <th>Net</th>
    </tr>
  `;

  let totalQty = 0;

  const rows = items
    .map((i) => {
      const units = Number(i.units) || 0;
      totalQty += units;

      return `
        <tr>
          <td>${i.slNo}</td>
          <td>${i.serviceName}</td>
          <td style="text-align:right;">${i.charges?.toFixed(2) || ""}</td>
          <td style="text-align:center;">${units}</td>
          <td style="text-align:right;">${i.netAmount?.toFixed(2) || ""}</td>
        </tr>
      `;
    })
    .join("");

  const itemCount = items.length;


  // Footer row (ITEMS + QTY)
 const footerHtml = `
<table class="service-footer-table" cellspacing="0" cellpadding="5">
  <tr>
    <td></td>
    <td><b>**TOTAL**</b></td>
    <td></td>
    <td><b>ITEMS : ${itemCount.toFixed(2)}</b></td>
    <td "><b>QTY : ${totalQty.toFixed(2)}</b></td>
  </tr>
</table>
`;



 
    return `
  <table class="service-table" border="1" cellspacing="0" cellpadding="5"
    style="border-collapse:collapse; font-size:12px; width:100%; table-layout:auto;">
    <thead>${header}</thead>
    <tbody>${rows}</tbody>
  </table>

  ${footerHtml}
`;

};
